export default "__VITE_ASSET__DLHfbxbV__"